import { __decorate, __metadata } from "tslib";
import { IsEmail } from 'class-validator';
import { IS_EMAIL_DEFAULT_OPTIONS } from '../../shared/validator';
/**
 * Requests an email with reset password instructions
 */
export class SendResetPasswordInstructionsBody {
    /**
     * @param email The email address to send the instructions to
     */
    constructor(email) {
        this.email = email;
    }
}
__decorate([
    IsEmail(IS_EMAIL_DEFAULT_OPTIONS),
    __metadata("design:type", String)
], SendResetPasswordInstructionsBody.prototype, "email", void 0);
